<section
  #dialog
  class="critical-update"
  role="alertdialog"
  aria-modal="true"
  aria-labelledby="critical-update-title"
  aria-describedby="critical-update-description"
  tabindex="-1"
  cdkTrapFocus
>
  <div class="critical-update__body" aria-live="polite">
    <div class="critical-update__mark" [class.critical-update__mark--failed]="isFailed()">
      <img ngSrc="/assets/images/logos/logo-icon-white.svg" width="30" height="36" alt="" priority />
    </div>

    <h1 id="critical-update-title" class="critical-update__title">{{ title() }}</h1>
    <p id="critical-update-description" class="critical-update__description">{{ description() }}</p>

    @if (!isFailed()) {
      <div
        class="critical-update__progress"
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-valuenow]="progress()"
        [attr.aria-label]="translations.progressLabel"
        [class.critical-update__progress--waiting]="progress() === 0"
      >
        <span class="critical-update__progress-fill" [style.width.%]="fillWidth()"></span>
      </div>
    }
  </div>

  @if (isFailed()) {
    <footer class="critical-update__footer">
      <aw-button
        size="l"
        [text]="translations.retry"
        [block]="true"
        [color]="'purple'"
        [variant]="'tertiary'"
        (onclick)="retry()"
      />
    </footer>
  }
</section>
